import sk from '@angular/common/locales/sk';
import { sk_SK } from 'ng-zorro-antd/i18n';
import dfnsSk from 'date-fns/locale/sk';
import { CrmTranslateConfig } from '@touch4it/ng-swp/translate';

export const translateConfig = {
  locale: {
    defaultLocale: 'sk',
    locales: {
      sk: { ngLocale: sk, nzLocale: sk_SK, dateFnsLocale: dfnsSk },
    },
  },
} satisfies CrmTranslateConfig;
